import validation from "uk-numberplate-format";

interface PlateNumberValidation {
    isValid: boolean;
    format?: string;
    formatedPlate?: string;
    plate?: string;
}

const PLATE_NUMBER_FORMATS = {
    P1: "[A-Z]{1}[0-9]{1}[A-Z]{3}", // A1 ABC
    P2: "[A-Z]{1}[0-9]{2}[A-Z]{3}", // A12 ABC
    P3: "[A-Z]{1}[0-9]{3}[A-Z]{3}", // A123 ABC
    S1: "[A-Z]{3}[0-9]{1}[A-Z]{1}", // ABC 1A
    S2: "[A-Z]{3}[0-9]{2}[A-Z]{1}", // ABC 12A
    S3: "[A-Z]{3}[0-9]{3}[A-Z]{1}", // ABC 123A
    MILLENNIUM: "[A-Z]{2}[0-9]{2}[A-Z]{3}", // AB12 ABC
    "1CT4D": "[A-Z]{1}[0-9]{4}", // A 1234
    "1CT3D": "[A-Z]{1}[0-9]{3}", // A 123
    "1CT2D": "[A-Z]{1}[0-9]{2}", // A 12
    "1CT1D": "[A-Z]{1}[0-9]{1}", // A 1
    "2CT4D": "[A-Z]{2}[0-9]{4}", // AA 1234
    "2CT3D": "[A-Z]{2}[0-9]{3}", // AA 123
    "2CT2D": "[A-Z]{2}[0-9]{2}", // AA 12
    "2CT1D": "[A-Z]{2}[0-9]{1}", // AA 1
    "3CT4D": "[A-Z]{3}[0-9]{4}", // AAA 1234 - IRISH MAINLY
    "3CT3D": "[A-Z]{3}[0-9]{3}", // AAA 123
    "3CT2D": "[A-Z]{3}[0-9]{2}", // AAA 12
    "3CT1D": "[A-Z]{3}[0-9]{1}", // AAA 1
    "4DT1C": "[0-9]{4}[A-Z]{1}", // 1234 A
    "3DT1C": "[0-9]{3}[A-Z]{1}", // 123 A
    "2DT1C": "[0-9]{2}[A-Z]{1}", // 12 A
    "1DT1C": "[0-9]{1}[A-Z]{1}", // 1 A
    "4DT2C": "[0-9]{4}[A-Z]{2}", // 1234 AA
    "3DT2C": "[0-9]{3}[A-Z]{2}", // 123 AA
    "2DT2C": "[0-9]{2}[A-Z]{2}", // 12 AA
    "1DT2C": "[0-9]{1}[A-Z]{2}", // 1 AA
    "4DT3C": "[0-9]{4}[A-Z]{3}", // 1234 AAA
    "3DT3C": "[0-9]{3}[A-Z]{3}", // 123 AAA
    "2DT3C": "[0-9]{2}[A-Z]{3}", // 12 AAA
    "1DT3C": "[0-9]{1}[A-Z]{3}", // 1 AAA
} as {
    [key: string]: string;
};

const validatePlateNumber = (input: string): PlateNumberValidation => {
    const clearInput = input
        .trim()
        .toUpperCase()
        .replace(" ", "")
        .replace("\r", "")
        .replace("\n", "");

    const reg = input.replace(/[\W\s]+/g, "").toUpperCase();

    if (clearInput !== reg || clearInput.indexOf("*") !== -1) {
        return {
            isValid: false,
        };
    }

    let result: PlateNumberValidation = {
        isValid: true,
    };

    for (let key in PLATE_NUMBER_FORMATS) {
        const v = "^" + PLATE_NUMBER_FORMATS[key] + "$";
        if (reg.match(String(v))) {
            result.format = key;
            break;
        }
    }

    if (!result.format) {
        return {
            isValid: false,
        };
    }

    const regArray = reg.split("");

    switch (result.format) {
        case "1CT4D":
            result.formatedPlate =
                regArray[0] + " " + regArray[1] + regArray[2] + regArray[3] + regArray[4];
            break;
        case "1CT3D":
            result.formatedPlate = regArray[0] + " " + regArray[1] + regArray[2] + regArray[3];
            break;
        case "1CT2D":
            result.formatedPlate = regArray[0] + " " + regArray[1] + regArray[2];
            break;
        case "1CT1D":
            result.formatedPlate = regArray[0] + " " + regArray[1];
            break;
        case "4DT1C":
            result.formatedPlate =
                regArray[0] + regArray[1] + regArray[2] + regArray[3] + " " + regArray[4];
            break;
        case "3DT1C":
            result.formatedPlate = regArray[0] + regArray[1] + regArray[2] + " " + regArray[3];
            break;
        case "2DT1C":
            result.formatedPlate = regArray[0] + regArray[1] + " " + regArray[2];
            break;
        case "1DT1C":
            result.formatedPlate = regArray[0] + " " + regArray[1];
            break;
        case "2CT4D":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                " " +
                regArray[2] +
                regArray[3] +
                regArray[4] +
                regArray[5];
            break;
        case "2CT3D":
            result.formatedPlate =
                regArray[0] + regArray[1] + " " + regArray[2] + regArray[3] + regArray[4];
            break;
        case "2CT2D":
            result.formatedPlate = regArray[0] + regArray[1] + " " + regArray[2] + regArray[3];
            break;
        case "2CT1D":
            result.formatedPlate = regArray[0] + regArray[1] + " " + regArray[2];
            break;
        case "4DT2C":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                regArray[3] +
                " " +
                regArray[4] +
                regArray[5];
            break;
        case "3DT2C":
            result.formatedPlate =
                regArray[0] + regArray[1] + regArray[2] + " " + regArray[3] + regArray[4];
            break;
        case "2DT2C":
            result.formatedPlate = regArray[0] + regArray[1] + " " + regArray[2] + regArray[3];
            break;
        case "1DT2C":
            result.formatedPlate = regArray[0] + " " + regArray[1] + regArray[2];
            break;
        case "3CT4D":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                " " +
                regArray[3] +
                regArray[4] +
                regArray[5] +
                regArray[6];
            break;
        case "3CT3D":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                " " +
                regArray[3] +
                regArray[4] +
                regArray[5];
            break;
        case "3CT2D":
            result.formatedPlate =
                regArray[0] + regArray[1] + regArray[2] + " " + regArray[3] + regArray[4];
            break;
        case "3CT1D":
            result.formatedPlate = regArray[0] + regArray[1] + regArray[2] + " " + regArray[3];
            break;
        case "4DT3C":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                regArray[3] +
                " " +
                regArray[4] +
                regArray[5] +
                regArray[6];
            break;
        case "3DT3C":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                " " +
                regArray[3] +
                regArray[4] +
                regArray[5];
            break;
        case "2DT3C":
            result.formatedPlate =
                regArray[0] + regArray[1] + " " + regArray[2] + regArray[3] + regArray[4];
            break;
        case "1DT3C":
            result.formatedPlate = regArray[0] + " " + regArray[1] + regArray[2] + regArray[3];
            break;
        case "P1":
            result.formatedPlate =
                regArray[0] + regArray[1] + " " + regArray[2] + regArray[3] + regArray[4];
            break;
        case "P2":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                " " +
                regArray[3] +
                regArray[4] +
                regArray[5];
            break;
        case "P3":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                regArray[3] +
                " " +
                regArray[4] +
                regArray[5] +
                regArray[6];
            break;
        case "S1":
            result.formatedPlate =
                regArray[0] + regArray[1] + regArray[2] + " " + regArray[3] + regArray[4];
            break;
        case "S2":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                " " +
                regArray[3] +
                regArray[4] +
                regArray[5];
            break;
        case "S3":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                " " +
                regArray[3] +
                regArray[4] +
                regArray[5] +
                regArray[6];
            break;
        case "MILLENNIUM":
            result.formatedPlate =
                regArray[0] +
                regArray[1] +
                regArray[2] +
                regArray[3] +
                " " +
                regArray[4] +
                regArray[5] +
                regArray[6];
            break;
    }

    return result;
};

export default validatePlateNumber;
